export default __webpack_public_path__ + "static/media/eshopPhoto.fd6633ba.png";